<template>
  <div v-if="showFilter" class="menu-item-attributes-filter iw-layout-grid">
    <div class="iw-layout-grid__row p-t-16 p-b-0">
      <div class="iw-layout-grid__col--span-12">
        <app-chips-bar
          :chips="getChipsList"
          :show-clean-button="getFilterEnabled"
          @cleanClick="clearFilterAttributes"
          @chipClick="switchItemSelected"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { sortAttributes, capFirstLetter } from "@/utils";
import AppChipsBar from "@/components/base/app-chips-bar/AppChipsBar";

export default {
  name: "MenuItemAttributesFilter",
  components: { AppChipsBar },
  computed: {
    ...mapGetters("vendor", {
      attributesList: "getUpdatedAttributeList",
      getFilterEnabled: "getFilterEnabled"
    }),
    showFilter() {
      if (!this.attributesList) return false;
      return !!Object.keys(this.attributesList).length;
    },
    getSortedList() {
      return Object.values(this.attributesList).sort(sortAttributes);
    },
    getChipsList() {
      return this.getSortedList.map(item => ({
        id: item.id,
        selected: item.selected,
        text: capFirstLetter(item.displayName || item.name)
      }));
    }
  },
  methods: {
    ...mapActions("vendor", {
      filterByAttribute: "filterItemsByAttribute",
      clearFilterAttributes: "clearFilterAttributes"
    }),
    switchItemSelected(e, id) {
      this.filterByAttribute(id);
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item-attributes-filter {
  width: 100%;
}
</style>
